export default __webpack_public_path__ + "static/logo_512-4ab717075f6baf6462c289947e1d5a17.png";